import script from "./WalletDeposit.vue?vue&type=script&setup=true&lang=js"
export * from "./WalletDeposit.vue?vue&type=script&setup=true&lang=js"

import "./WalletDeposit.vue?vue&type=style&index=0&id=411bd2b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-411bd2b8"]])

export default __exports__